import { Component, Input, OnChanges } from '@angular/core';

import { HtmlService } from '../../../../../../services/html.service';

@Component({
    selector: 'slide-deck',
    template: require('./slide-deck.component.html'),
})
export class SlideDeckComponent implements OnChanges {
    @Input() pics: number[];
    currentIndex: number;
    picUrl: string;

    constructor(private htmlService: HtmlService) { }

    ngOnChanges() {
        this.currentIndex = 0;
        this.updatePicUrl();
    }

    prev() {
        if (this.currentIndex >= 1) {
            this.currentIndex--;
            this.updatePicUrl();
        }
    }

    next() {
        if (this.currentIndex < this.pics.length - 1) {
            this.currentIndex++;
            this.updatePicUrl();
        }
    }

    updatePicUrl() {
        if (this.pics && this.currentIndex < this.pics.length) {
            this.picUrl = this.htmlService.getResourceUrl(this.pics[this.currentIndex]);
        }
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/resource/slide-deck/slide-deck.component.ts